import React from 'react';

import { FormControlLabel, Grid } from '@mui/material';
import { StyledRadio } from '../../styled/radio.input';
import { StyledRadioGroup } from '../../styled/radiogroup.input';

export const RadioInput = ({
  field,
  design,
  onChange,
  value,
  isTwoColumn,
}: any) => {
  return (
    <Grid>
      <StyledRadioGroup
        name={field.id}
        onChange={onChange}
        value={value}
        design={design}
      >
        <Grid container direction={isTwoColumn ? 'row' : 'column'} spacing={1}>
          {field.options.map((option: any) => (
            <Grid item xs={isTwoColumn ? 6 : 12} key={option.id}>
              <FormControlLabel
                value={option.value}
                sx={{
                  transition: 'box-shadow 0.1s linear',
                  borderColor:
                    value === option.value
                      ? 'transparent'
                      : design.colors.question,
                  boxShadow:
                    value === option.value
                      ? `0 0 0 5px ${design.colors.button}`
                      : `0 0 0 1px ${design.colors.question}`,
                  width: isTwoColumn ? '100%' : 'auto',
                  maxWidth: isTwoColumn ? '100%' : 'none',
                  flex: isTwoColumn ? '0 0 50%' : undefined,
                  display: 'flex',
                }}
                control={<StyledRadio design={design} size='small' />}
                label={
                  <span
                    style={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {option.title}
                  </span>
                }
              />
            </Grid>
          ))}
        </Grid>
      </StyledRadioGroup>
    </Grid>
  );
};
